// extracted by mini-css-extract-plugin
export default {"button":"hm-z","reviewSort":"im-z"};